"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/ispAmountInput/index.vue"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _user = require("@/api/system/user");
var _auth = require("@/utils/auth");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "ReadWebOnlineTerms",
  components: {
    dragDialog: _DragDialog.default,
    amountInput: _index.default
  },
  props: {
    bookingTermNo: {
      type: String,
      default: ''
    },
    registerTermNo: {
      type: String,
      default: ''
    },
    registerTermContent: {
      type: String,
      default: ''
    },
    bookingTermContent: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: null,
      title: ''
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    opened: function opened() {
      this.title = this.$t('home.readWebOnlineTerm');
    },
    closed: function closed() {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs['form'].clearValidate();
      });
    },
    clearSessionStorage: function clearSessionStorage() {
      sessionStorage.removeItem("updateRegisterTermNo");
      sessionStorage.removeItem("updateBookingTermNo");
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      var terms = [];
      if (this.registerTermNo) {
        terms.push(this.registerTermNo);
      }
      if (this.bookingTermNo) {
        terms.push(this.bookingTermNo);
      }
      (0, _user.updateTermNo)(terms).then(function (res) {
        _this2.loading.close();
        if (res.success) {
          _this2.clearSessionStorage();
          _this2.$parent.setInitDialogReadWebOnlineTermsVisible(false);
        }
      }).catch(function () {
        _this2.loading.close();
      });
    },
    handleCancel: function handleCancel() {
      (0, _auth.removeToken)();
      this.clearSessionStorage();
      // 退出登录后清除用户权限
      this.$store.dispatch('user/logoutAuth');
      this.$router.push({
        path: '/home'
      });
    }
  }
};